<template>
  <ion-page>
    <ion-content
      :id="id"
      fullscreen="false"
      class="master"
      :scroll-events="enableScrollEvent"
      @ionScroll="onScroll"
    >
      <main class="lg:flex h-full">
        <slot class="flex-1" test="test"> </slot>
      </main>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent, isPlatform } from '@ionic/vue';
import { mapGetters, mapState } from 'vuex';
import { StatusBar } from '@capacitor/status-bar';
import { isIosNativeOnly } from '@/utils/platform-check';
import { lockToPortrait } from '@/utils/screen-orientation';
import { hasStatusBarClaim } from '@/utils/status-bar-claims';

export default {
  name: 'MyGivingLayout',
  components: {
    IonPage,
    IonContent,
  },
  props: {
    id: {
      type: String,
      default: 'main-content',
    },
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollY: 0,
    };
  },
  computed: {
    ...mapState('user', ['token']),
    ...mapGetters('user', ['isLoggedIn']),
  },
  methods: {
    onScroll(event) {
      this.scrollY = event.detail.scrollY;
      this.$emit('scroll', event);
    },
    isIos() {
      return isIosNativeOnly();
    },
  },
  async mounted() {
    await lockToPortrait();
    // Set status bar style for iOS, unless a screen has claimed it (the BF2026
    // pages, whose navy needs light icons).
    if (isPlatform('ios') && !hasStatusBarClaim()) {
      try {
        await StatusBar.setStyle({ style: 'light' });
        await StatusBar.setBackgroundColor({ color: '#F2EFED' });
      } catch (error) {
        console.log('Status bar not available');
      }
    }
  },
  async beforeUnmount() {
    await lockToPortrait();
  },
};
</script>

<style scoped>
.master {
  --background: #f6f4f0;
}

.box-shadow {
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}
</style>
